import {type DropdownNs} from "@shared/types/dropdown.namespace";

export namespace CommonNs {

  export type AnyResponse = any

  export interface GenericResponse {
    result: boolean
  }

  export type InputType =
      'text'
      | 'textarea'
      | 'multiselect'
      | 'description-dropdown'
      | 'add-dropdown'
      | 'range'
      | 'password'
      | 'select'
      | 'checkbox'
      | 'switch'
      | 'button'
      | 'workspaces'
      | 'login-activity'
      | 'assigned-list'
      | 'toggle'
      | 'radio'

  export interface CallbackButton {
    type: string,
    label: string,
    class: string,
    callback: Function
  }

  export enum PermissionsEnums {
    EVERYONE = 'EVERYONE',
    ONLY_YOU = 'ONLY_YOU'
  }


  export enum ImageBucketEnums {
    SCREEN_BUCKET = 'SCREEN_BUCKET',
    USER_IMAGE_BUCKET = 'USER_IMAGE_BUCKET',
    USER_COVER_BUCKET = 'USER_COVER_BUCKET',
    COMPANY_COVER_BUCKET = 'COMPANY_COVER_BUCKET',
    COMPANY_IMAGE_BUCKET = 'COMPANY_IMAGE_BUCKET',
    EDITOR_IMAGE_BUCKET = 'EDITOR_IMAGE_BUCKET',
  }

  export interface ImageData {
    name: string,
    type: string,
    file: any,
  }

  export interface Breadcrumb {
    text: string,
    to: string,
  }

  export interface FormItem {
    id: string,
    value: string,
    name: string,
    label: string
  }

  export enum InputTypeEnums {
    TEXT = 'text',
    PASSWORD = 'password',
    NUMBER = 'number',
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
    EMAIL = 'email'
  }

  export interface Input {
    name: string,
    type: InputType,
    placeholder?: string,
    description?: string,
    isDisable?: boolean,
    isLocked?: boolean,
    withButton?: boolean,
    callbackButton?: CallbackButton,
    value?: any,
    selectOptions?: DropdownNs.DropdownOptionsItem[],
  }

  export interface InputFormGroup {
    label: string,
    icon: string,
    iconType: string,
    input: Input,
    description?: string,
    dropdown?: DropdownNs.Dropdown,
    id?: number,
    isFixed?: boolean,
    isCustom?: boolean;
  }

  export interface CallbackButton {
    type: string,
    label: string,
    callback: Function,
    class: string,
  }

  export interface IndividualTag {
    title: string,
    value: string,
    status: 'active' | 'inactive'
  }

  export enum WorkspaceRoleEnums {
    OWNER = 'OWNER',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER'
  }

  export enum SocketEventType {
    PACKAGE_CHANGE = 'PACKAGE_CHANGE',
  }

  export interface SocketEvent {
    type: SocketEventType,
    time: Date,
    payload: any
  }

}
